import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var MailIcon = function MailIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.002 15.546",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, [h("g", {
    transform: "translate(.75 .75)"
  }, h("rect", {
    width: "23.502",
    height: "14.046",
    fill: "none",
    stroke: (_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#2b5dff",
    "stroke-width": "1.5",
    rx: "2"
  })), h("path", {
    fill: "none",
    stroke: (_d = attrs["stroke-color"]) !== null && _d !== void 0 ? _d : "#2b5dff",
    "stroke-linecap": "round",
    "stroke-width": "1.5",
    d: "m5.604 4.488 6.054 4.52a1.11 1.11 0 0 0 1.386 0l6.594-4.52"
  })]);
};